import { render } from "./UpdateExpenseModal.vue?vue&type=template&id=7c51d629"
import script from "./UpdateExpenseModal.vue?vue&type=script&lang=js"
export * from "./UpdateExpenseModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__